import React from 'react';
import { Pie, Line } from 'react-chartjs-2';

const ChildrenTab = ({ filters }) => {
  const tableData = [
    { district: 'Оболонський', age1_2: 410, age2_3: 340, age3_4: 160, age4_5: 165, age5_6: 92, age6_7: 175, age7_8: 220, total: 2400, total3_6: 1650 },
    // ... остальные данные
  ];

  const totalRow = {
    district: 'По Києву',
    age1_2: 3244,
    age2_3: 3451,
    age3_4: 2898,
    age4_5: 2456,
    age5_6: 3102,
    age6_7: 3210,
    age7_8: 2654,
    total: 22878,
    total3_6: 12399
  };

  const pieData = {
    labels: ['1-2 роки', '2-3 роки', '3-4 роки', '4-5 років', '5-6 років', '6-7 років', '7-8 років'],
    datasets: [
      {
        data: [3244, 3451, 2898, 2456, 3102, 3210, 2654],
        backgroundColor: [
          '#e8a898',
          '#f4d03f',
          '#e74c3c',
          '#58d68d',
          '#a9dfbf',
          '#f7dc6f',
          '#3498db'
        ],
        borderWidth: 0,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: '60%',
  };

  return (
    <>
      <div className="publicstatistic-statistics-table-section">
        <h3 className="publicstatistic-section-title">
          Діти в садочках на {filters.year} навчальний рік
        </h3>

        <div className="publicstatistic-table-responsive">
          <table className="table publicstatistic-statistics-table">
            <thead>
              <tr>
                <th>Район</th>
                <th>1-2 роки</th>
                <th>2-3 роки</th>
                <th>3-4 роки</th>
                <th>4-5 роки</th>
                <th>5-6 роки</th>
                <th>6-7 роки</th>
                <th>7-8 роки</th>
                <th>Разом</th>
                <th>Разом 3-6</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td className="publicstatistic-district-name">{row.district}</td>
                  <td>{row.age1_2}</td>
                  <td>{row.age2_3}</td>
                  <td>{row.age3_4}</td>
                  <td>{row.age4_5}</td>
                  <td>{row.age5_6}</td>
                  <td>{row.age6_7}</td>
                  <td>{row.age7_8}</td>
                  <td>{row.total}</td>
                  <td>{row.total3_6}</td>
                </tr>
              ))}
              <tr className="publicstatistic-total-row">
                <td className="publicstatistic-district-name"><strong>{totalRow.district}</strong></td>
                <td><strong>{totalRow.age1_2}</strong></td>
                <td><strong>{totalRow.age2_3}</strong></td>
                <td><strong>{totalRow.age3_4}</strong></td>
                <td><strong>{totalRow.age4_5}</strong></td>
                <td><strong>{totalRow.age5_6}</strong></td>
                <td><strong>{totalRow.age6_7}</strong></td>
                <td><strong>{totalRow.age7_8}</strong></td>
                <td><strong>{totalRow.total}</strong></td>
                <td><strong>{totalRow.total3_6}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {false && <div className="publicstatistic-charts-section">
        <div className="row">
          <div className="col-lg-6">
            <div>
              <h4 className="publicstatistic-chart-title">Розподіл дітей за віком</h4>
              <div className="publicstatistic-chart-wrapper">
                <div className="publicstatistic-chart-legend-top">
                  {pieData.labels.map((label, index) => (
                    <div key={index} className="publicstatistic-legend-item">
                      <span
                        className="publicstatistic-legend-color"
                        style={{ backgroundColor: pieData.datasets[0].backgroundColor[index] }}
                      ></span>
                      <span>{label.split(' ')[0]}</span>
                    </div>
                  ))}
                </div>
                <div className="publicstatistic-custom-pie-chart">
                  <div className="publicstatistic-pie-chart-center">
                    <span className="publicstatistic-chart-total">66783</span>
                  </div>
                  <Pie data={pieData} options={pieOptions} />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div>
              <h4 className="publicstatistic-chart-title">Динаміка дітей</h4>
              <div className="publicstatistic-chart-wrapper">
                <div className="publicstatistic-custom-area-chart">
                  <div className="publicstatistic-chart-total-center">
                    <span className="publicstatistic-chart-total">66783</span>
                  </div>
                  {/* Line chart для динамики детей */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};

export default ChildrenTab;